import { post } from "@rails/request.js";

import FormController from "@controllers/portal/components/form_controller";

export default class extends FormController {
  static targets = ['applyDecorationButton'];
  static outlets = ['dropdown'];
  static values = {
    url: String,
  };


  connect() {
    super.connect();
  }

  async applyDecorations(e) {
    e.preventDefault();
    
    const buttonController = this.getControllerByElement(this.applyDecorationButtonTarget);
    buttonController.toggleLoading(true);
    
    const url = this.urlValue;
    // decoration dropdown
    const dropdown = this.dropdownOutlet;
    const selectedIds = dropdown.selections();

    post(url, {
      // eslint-disable-next-line camelcase
      body: JSON.stringify({ decoration_ids: selectedIds }),
      contentType: 'application/json',
      responseKind: 'turbo-stream',
    }).then(() => {
      buttonController.toggleLoading(false);
    });
  }
}